
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M5.70998 9.69997C6.09998 10.09 6.72998 10.09 7.11998 9.69997L11 5.82997V21C11 21.55 11.45 22 12 22C12.55 22 13 21.55 13 21V5.82997L16.88 9.70997C17.27 10.1 17.9 10.1 18.29 9.70997C18.68 9.31997 18.68 8.68997 18.29 8.29997L12.7 2.69997C12.31 2.30997 11.68 2.30997 11.29 2.69997L5.70998 8.28997C5.31998 8.67997 5.31998 9.31997 5.70998 9.69997Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-north`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNorth

    ```js
    <b-new-b-icon-north />
    ```
</docs>


